import { useTranslation } from 'react-i18next';

import { Button, Typography, AcceptOffer } from '@/components';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from '@/components/dialog';
import { useState } from 'react';
import { Slot } from './action-offer-modals';
import { AvailabilitySlotsPicker } from '../slots-picker';

export type AcceptOfferModalProps = {
  readonly open?: boolean;
  readonly setOpen?: (state: boolean) => void;
  readonly onClose: () => void;
  readonly onAcceptOffer: () => void;
  readonly slots: Slot[];
  readonly setSlots: React.Dispatch<React.SetStateAction<Slot[]>>;
};

export function AcceptOfferModal({
  open = false,
  setOpen,
  onClose,
  onAcceptOffer,
  slots,
  setSlots,
}: AcceptOfferModalProps) {
  const { t } = useTranslation(['offers']);
  const [availabilitySlots, setAvailabilitySlots] = useState<Slot[]>([]);
  const MIN_SLOTS_LENGTH = 3;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent onPointerDownOutside={(event) => event.preventDefault()}>
          <DialogHeader>
            <DialogTitle>{t('Accept Expression of Interest')}</DialogTitle>
          </DialogHeader>
          <div className="flex flex-col gap-7 md:flex-row">
            <div className="w-full space-y-2">
              <Typography as="h5" color="primary" weight="normal" className="mb-4 text-start">
                {t('Pick 1-hour slots over the next 3 weeks for the kick-off call (45 min)')}
              </Typography>
              <Typography as="p" size="body-2" color="secondary" weight="normal" className="text-start">
                {t(
                  'The proposed time slots will be sent to the buyer to coordinate an introductory call. The objective is to get to know each other, clarify doubts and define the next steps of the process.'
                )}
              </Typography>
            </div>
            <AcceptOffer className="mx-auto my-4 w-40 md:w-1/3" />
          </div>
          <AvailabilitySlotsPicker onSlotsChange={setAvailabilitySlots} slots={slots} setSlots={setSlots} />
          <DialogFooter>
            <div className="mt-4 flex justify-end space-x-4">
              <Button type="button" color="neutral" onClick={onClose}>
                {t('Close')}
              </Button>
              <Button
                type="button"
                color="primary"
                icon="thumb-up"
                onClick={() => onAcceptOffer()}
                disabled={availabilitySlots.length < MIN_SLOTS_LENGTH}
              >
                {t('Confirm & send')}
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
